// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Btr3sENGO_yiUdjq7oww{display:flex;align-items:center;gap:8px}.hWaoj3Yyt4OeGamL7YMW{flex-shrink:0}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/doubleOptIn/ui/QuietHoursSettings/ui/QuietHoursTable/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,kBAAA,CACA,OAAA,CAGF,sBACE,aAAA","sourcesContent":[".timeRangeCell {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.timeRangeIcon {\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"timeRangeCell": `Btr3sENGO_yiUdjq7oww`,
	"timeRangeIcon": `hWaoj3Yyt4OeGamL7YMW`
};
export default ___CSS_LOADER_EXPORT___;
